module.exports = __webpack_public_path__ + "static/globe-4d993ca8daa03c980bb048c4d04f8d64.png";